<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.microsoft.security_group_management.about' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (!isLoading) {
      <div>
        <ziro-security-group-management-form
          [securityOptions]="securityOptions"
          [securityGroups]="securityGroups"
          [entity]="formEntity"
          [tenantId]="tenantInfo?.tenantId"
        ></ziro-security-group-management-form>
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
